import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidateChargeDetailResponse from "./customerRefundCandidateChargeDetailResponse";
import CustomerRefundCandidateFeeResponse from "./customerRefundCandidateFeeResponse";
import CustomerRefundCandidatePayGatePaymentResponse from "./customerRefundCandidatePayGatePaymentResponse";
import CustomerRefundCandidateTransferPaymentResponse from "./customerRefundCandidateTransferPaymentResponse";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import RejectedCustomerRefundCandidatePermittedActionsResponse from "./rejectedCustomerRefundCandidatePermittedActionsResponse";
import RejectedCustomerRefundCandidateStatus from "./rejectedCustomerRefundCandidateStatus";
import CustomerRefundCandidateRefundPaymentResponse from "./customerRefundCandidateRefundPaymentResponse";
import CustomerRefundType from "./customerRefundType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RejectedCustomerRefundCandidateDetailResponse {
  id!: string;

  @observable
  @Type(() => Date)
  rejectionDate!: Date;

  @observable
  status!: RejectedCustomerRefundCandidateStatus;

  @observable
  rejectionReason!: string;

  @observable
  rejectedBy!: string;

  @observable
  refundType!: CustomerRefundType;

  @observable
  officialRecordId!: string;

  @observable
  isWithoutRefundFee!: boolean;

  @observable
  refundAmount!: number;

  @observable
  requestedPriceListItemId!: string;

  @observable
  variableSymbol!: number;

  @observable
  @Type(() => CustomerRefundCandidateChargeDetailResponse)
  charge!: CustomerRefundCandidateChargeDetailResponse;

  @observable
  @Type(() => CustomerRefundCandidatePayGatePaymentResponse)
  originalPayGatePayment?: CustomerRefundCandidatePayGatePaymentResponse;

  @observable
  @Type(() => CustomerRefundCandidateTransferPaymentResponse)
  originalTransferPayment?: CustomerRefundCandidateTransferPaymentResponse;

  @observable
  @Type(() => DomesticBankAccountResponse)
  refundSenderBankAccount!: DomesticBankAccountResponse;

  @observable
  @Type(() => CustomerRefundCandidateRefundPaymentResponse)
  refundPayment!: CustomerRefundCandidateRefundPaymentResponse;

  @observable
  @Type(() => CustomerRefundCandidateFeeResponse)
  fees!: CustomerRefundCandidateFeeResponse[];

  @observable
  @Type(() => RejectedCustomerRefundCandidatePermittedActionsResponse)
  permittedActions!: RejectedCustomerRefundCandidatePermittedActionsResponse;
}
